import { jsx as _jsx } from "react/jsx-runtime";
import { MenuItems } from './menu-items';
import styles from './navigation-menu.css';
export function Navbar() {
    return (_jsx("div", { className: styles.defaultMenuWrapper, children: _jsx(MenuItems, { variant: "default" }) }));
}
